import React from 'react';
import styled from 'styled-components';

import { theme } from '_constants/theme';

import AmendmentRequestView from 'components/composed/views/AmendmentRequestView';
import TaxReturnsView from 'components/composed/views/TaxReturnsView';

const StyledContainer = styled.div`
  display: grid;
  grid-template-columns: 50% 50%;
  gap: ${theme.spaces.smallX}px;
  width: 100%;

  @media ${theme.devices.tablet} {
    grid-template-columns: 100%;
  }
`;

const PreviousTaxYearsSection = () => {
  return (
    <StyledContainer>
      <TaxReturnsView />
      <AmendmentRequestView />
    </StyledContainer>
  );
};

export default PreviousTaxYearsSection;
